// extracted by mini-css-extract-plugin
module.exports = {"actions":"ImageActionsCell1_actions_1S9yl","redCrossImage":"ImageActionsCell1_redCrossImage_fxkvn"};